import { render } from "./AboutView.vue?vue&type=template&id=4c5f84f8"
const script = {}

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__